import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import { Box, Flex, Hide, NakedButton } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';
import theme from 'lib/theme';
import PulsingLoadingBlock from 'components/PulsingLoadingBlock';
import { PropertyCardSkeleton } from 'components/PropertyCard';

export const SkeletonNavDesktop = React.memo(() => {
  return (
    <Flex height={33} mt={2} ml={4}>
      <PulsingLoadingBlock height={18} mr={4} width={70} />
      <PulsingLoadingBlock height={18} mr={4} width={50} />
      <PulsingLoadingBlock height={18} mr={4} width={70} />
      <PulsingLoadingBlock height={18} mr={4} width={50} />
      <PulsingLoadingBlock height={18} mr={4} width={70} />
    </Flex>
  );
});

SkeletonNavDesktop.displayName = 'SkeletonNavDesktop';

export const SkeletonNavMobile = React.memo(() => {
  return (
    <Flex height={33} justifyContents="end" pr={[0, 2, 0]}>
      <PulsingLoadingBlock height={18} width={80} mt={3} />
    </Flex>
  );
});

SkeletonNavMobile.displayName = 'SkeletonNavMobile';

export const NavLink = styled(NakedButton)`
  background: transparent;
  color: ${themeGet('colors.greys.charcoal')};
  padding-bottom: ${themeGet('space.2')};
  margin-right: ${themeGet('space.6')};
  border-bottom: 2px solid;
  border-color: ${(props) => (props.isActive ? themeGet('colors.brand.primary') : 'transparent')};
  transition: border-color 0.2s ease-in-out;
  font-size: ${themeGet('fontSizes.base')};
  &:hover,
  &:focus {
    border-color: ${themeGet('colors.brand.primary')};
  }

  &:hover {
    outline: none;
  }

  &:focus {
    outline: 2px solid ${themeGet('colors.ui.linkFocus')};
  }
`;

const PulsingDot = () => {
  return <PulsingLoadingBlock borderRadius={50} height={10} width={10} mr={4} mt={5} display="inline-block" />;
};

export const SkeletonNavDots = () => (
  <Flex height={20} justifyContent="center" alignItems="center" pb={2}>
    <PulsingDot />
    <PulsingDot />
    <PulsingDot />
  </Flex>
);

export const SkeletonResultsMobile = () => {
  return (
    <Flex height="100%" width="100%" pt={2}>
      <Box>
        <PulsingLoadingBlock {...theme.imageSizes.mapSearchResult} borderRadius={5} />
      </Box>

      <Flex alignItems="space-between" flexDirection="column" pt={7} pl={2} width="100%">
        <Box mt={2}>
          <PulsingLoadingBlock height={18} width={120} />
          <PulsingLoadingBlock height={12} width={100} pt={2} />
        </Box>
        <Flex flexDirection="column" alignItems="flex-end" mt={5} width="100%">
          <PulsingLoadingBlock height={14} width={90} />
          <PulsingLoadingBlock height={36} width={70} />
          <PulsingLoadingBlock height={14} width={120} />
          <PulsingLoadingBlock height={14} width={130} />
        </Flex>
      </Flex>
    </Flex>
  );
};

SkeletonResultsMobile.displayName = 'SkeletonResultsMobile';

const Grid = styled(Flex)`
  width: 100%;
  height: 240px;
  > * {
    width: 32%;
    height: 100%;
    margin-right: ${themeGet('space.5')};
  }
`;

const SkeletonResultsDesktop = React.memo(() => (
  <Grid>
    <PropertyCardSkeleton />
    <PropertyCardSkeleton />
    <PropertyCardSkeleton />
  </Grid>
));

SkeletonResultsDesktop.displayName = 'SkeletonResultsDesktop';

export const SkeletonResults = () => (
  <Fragment>
    <Hide xs sm>
      <SkeletonResultsDesktop />
    </Hide>
    <Hide md lg>
      <SkeletonResultsMobile />
    </Hide>
  </Fragment>
);
